<template>
  <v-container class="app-container--width-max">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "B2BRentProtectionMainLayout",
};
</script>

<style scoped>
.app-container--width-max {
  max-width: 1250px;
}
</style>
